<template>
  <div class="nav">
    <div class="container-fluid">
      <button class="btn btn-link hambur px-3" @click="HidedNav">
        <i class="bi bi-list-nested"></i>
      </button>
      <img src="@/assets/images/AdminLOGO.svg" alt="logo" />
      <div class="float-end" v-if="user">
        <div class="user dropdown">
          Hi, {{ user.name }}
          <button
            class="ms-2 btn btn-link user-dropdown text-decoration-none"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            id="dropdownMenuLink"
          >
            {{ user.name.slice(0, 1) }}
          </button>
          <ul
            class="dropdown-menu text-center"
            aria-labelledby="dropdownMenuLink"
            style="max-width: 200px"
          >
            <li><a class="dropdown-item" href="#" @click="signOut">登出</a></li>
            <li><hr class="dropdown-divider" /></li>
            <li class="px-3">
              <small class="d-block fw-light">
                Client： <span class="text-primary">{{ clientName }}</span>
                <div>
                  Version： <span class="text-primary">{{ version }}</span>
                </div>
              </small>
              <small class="d-block fw-light"
                >© 2021 - {{ new Date().getFullYear() }} 釦釘資訊工作室 All
                rights reserved.</small
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { auth } from '@/http/api/auth.js'
import { mapState, mapMutations, mapGetters } from 'vuex'

export default {
  name: 'Navbar',
  data () {
    return {
      version: process.env.PACKAGE_VERSION,
      user: null
    }
  },
  computed: {
    ...mapState(['token']),
    ...mapGetters(['clientName'])
  },
  watch: {
    'token.headers.Authorization': function (data) {
      if (data) {
        this.initialEvent()
      }
    }
  },
  methods: {
    ...mapMutations(['HidedNav', 'SetErrMsg']),
    initialEvent () {
      this.getUser()
    },
    signOut () {
      localStorage.removeItem('codingIt_admin_token')
      this.$router.push({ name: 'Login' })
    },
    getUser () {
      const vm = this
      auth
        .get(vm.token)
        .then((res) => {
          if (res.status <= 201 && res.data.status === 'success') {
            vm.user = res.data.data
          } else {
            vm.SetErrMsg(res.data.errMsg)
          }
        })
        .catch((err) => {
          vm.SetErrMsg(err)
        })
    }
  },
  created () {},
  mounted () {
    const vm = this
    if (vm.token.headers.Authorization) {
      vm.initialEvent()
    }
  }
}
</script>

<style lang="scss">
.nav {
  position: relative;
  padding-top: 20px;
  margin-bottom: 20px;
  padding-bottom: 18px;
  color: #fff;
  z-index: 2;
  .hambur {
    color: #fff;
    &:focus {
      box-shadow: none;
    }
  }
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: rgba(#fff, 0.2);
    z-index: 0;
  }
  .user {
    line-height: 35px;
    &-dropdown {
      color: #fff;
      width: 35px;
      height: 35px;
      text-align: center;
      padding: 0;
      background: rgba(#fff, 0.4);
      border-radius: 3px;
    }
  }
}
</style>
